/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityAssetsDomainDnsRecordAnswer } from './ControlEntityAssetsDomainDnsRecordAnswer';
import {
    ControlEntityAssetsDomainDnsRecordAnswerFromJSON,
    ControlEntityAssetsDomainDnsRecordAnswerFromJSONTyped,
    ControlEntityAssetsDomainDnsRecordAnswerToJSON,
} from './ControlEntityAssetsDomainDnsRecordAnswer';

/**
 * 
 * @export
 * @interface ControlEntityAssetsDomainDnsRecord
 */
export interface ControlEntityAssetsDomainDnsRecord {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetsDomainDnsRecord
     */
    type: string;
    /**
     * 
     * @type {Array<ControlEntityAssetsDomainDnsRecordAnswer>}
     * @memberof ControlEntityAssetsDomainDnsRecord
     */
    answers?: Array<ControlEntityAssetsDomainDnsRecordAnswer>;
}

/**
 * Check if a given object implements the ControlEntityAssetsDomainDnsRecord interface.
 */
export function instanceOfControlEntityAssetsDomainDnsRecord(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function ControlEntityAssetsDomainDnsRecordFromJSON(json: any): ControlEntityAssetsDomainDnsRecord {
    return ControlEntityAssetsDomainDnsRecordFromJSONTyped(json, false);
}

export function ControlEntityAssetsDomainDnsRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityAssetsDomainDnsRecord {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'answers': !exists(json, 'answers') ? undefined : ((json['answers'] as Array<any>).map(ControlEntityAssetsDomainDnsRecordAnswerFromJSON)),
    };
}

export function ControlEntityAssetsDomainDnsRecordToJSON(value?: ControlEntityAssetsDomainDnsRecord | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'answers': value.answers === undefined ? undefined : ((value.answers as Array<any>).map(ControlEntityAssetsDomainDnsRecordAnswerToJSON)),
    };
}

